<template>
  <div>
    <OverlayPanel
      :ref="'opActions'"
      @click="toggle"
      appendTo="body"
      :showCloseIcon="true"
      id="overlay_panel"
      style="width: 100px; height: 50px;"
      :baseZIndex="-10"
    >
      <div style="padding: 0px 1px">
        <div class="row" style="background-color: white">
          <div
            class="p-field p-col"
            v-for="(obj, index) in actionButtons1"
            :key="index"
            style="display: flex; justify-content: center;"
          >
            <Button
              :label="obj.label"
              :icon="obj.icon"
              :disabled="obj.disabled ? obj.disabled : false"
              class="p-button-text p-button-plain"
              @click="runFunction(obj)"
            />
          </div>
        </div>
      </div>
    </OverlayPanel>

      <!-- :selection.sync="selectedRow"
      selectionMode="single" -->
    <DataTable
      :value="widgets"
      responsiveLayout="scroll"
      :rowHover="true"
      :loading="loading"
      :resizableColumns="true"
      columnResizeMode="expand"
      :scrollable="true"
      scrollHeight="400px"
      frozenWidth="50px"
    >
      <Column
        header="Actions"
        headerStyle="width: 50px; height: 20px; padding: 14.65px 0px;"
        :frozen="true"
      >
        <template #body="slotProps">
          <div style="height: 20px; display: flex; align-items: center">
            <Button
              icon="pi pi-ellipsis-v"
              class="p-button-rounded p-button-text"
              @click="toggleActions($event, slotProps.data)"
            />
          </div>
        </template>
      </Column>
      <Column
        field="widgetTitle"
        header="Widget Title"
        headerStyle="width: 6em"
        :sortable="true"
      >
        <template #body="slotProps">
          {{ slotProps.data.widgetTitle }}
        </template>
      </Column>
      <Column
        field="widget.widgetName"
        header="Widget Name/Description"
        headerStyle="width: 10em"
        :sortable="true"
      >
      </Column>
      <Column
        field="screenPos"
        header="Screen Position"
        headerStyle="width: 3em"
        :sortable="true"
      >
        <template #body="slotProps">
          {{ slotProps.data.screenPos }}
        </template>
      </Column>
      <Column
        field="widgetType"
        header="Widget Type"
        headerStyle="width: 5em"
        :sortable="true"
      >
        <template #body="slotProps">
          {{ slotProps.data.widgetType }}
        </template>
      </Column>
      <Column
        field="active"
        header="Active ?"
        headerStyle="width: 3em"
        :sortable="true"
      >
        <template #body="slotProps">
          <span v-if="slotProps.data.active">YES</span>
          <span v-else>NO</span>
        </template>
      </Column>
    </DataTable>
  </div>
</template>

<script>
export default {
  updated() {
    this.setFirstTableRowsHeight()
  },
  props: ["widgets", "loading", "search"],
  data: () => ({
    selectedRow: null,

    actionButtons1: [
      {
        label: "Edit",
        icon: "pi pi-pencil",
        command: (that) => {
          that.$emit("editWidget", that.selectedRow);
        },
      },
    ],
  }),
  computed: {
    getAppWindowWidth() {
      return this.$store.getters.getAppWindowWidth;
    },
    getAppWindowHeight() {
      return this.$store.getters.getAppWindowHeight;
    },
  },
  watch: {
    widgets(val) {
      setTimeout(() => {
        this.setFirstTableRowsHeight();
      }, 10);
    },
    getAppWindowWidth() {
      this.setFirstTableRowsHeight();
    },
    getAppWindowHeight() {
      this.setFirstTableRowsHeight();
    },
  },
  methods: {
    setFirstTableRowsHeight() {
      let tables = document.getElementsByClassName("p-datatable-tbody");

      if (tables && tables.length >= 2) {
        let tableFrom = tables[tables.length - 1],
          tableTo = tables[tables.length - 2];

        if (tableFrom && tableTo) {
          let rows = tableFrom.children;

          if (rows && rows.length) {
            for (let i = 0; i < rows.length; i++) {
              let properties = rows[i].getBoundingClientRect();

              if (properties && tableTo.children[i]) {
                tableTo.children[i].style.height =
                  properties.height.toString() + "px";
              }
            }
          }
        }
      }
    },
    runFunction(obj) {
      this.$refs.opActions.hide();
      obj.command(this);
    },
    toggleActions(event, data) {
      this.selectedRow = data;
      this.$refs.opActions.toggle(event);
    },
    async toggle(event) {
      this.$refs.op.toggle(event);
    },
  },
};
</script>

<style>
</style>